var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFordLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 550 550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: 14.03,
    x2: 537.03,
    y1: 284.93,
    y2: 284.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c1c0c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d9dee2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 13.51,
    x2: 537.55,
    xlinkHref: "#linear-gradient",
    y1: 284.93,
    y2: 284.93
  }))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 52",
    id: "Layer_52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.62,186C131.07,186,14,230.37,14,285s117,98.84,261.59,98.84C420,383.85,537,339.65,537,285S420,186,275.62,186Zm-2.34,190.77c-134.65,0-243.7-41.17-243.7-92.08s109.05-92.23,243.7-92.23S516.83,233.8,516.83,284.7,407.78,376.78,273.28,376.78Z",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "1.0447669148979648px",
      fillRule: "evenodd",
      fill: "url(#linear-gradient)",
      stroke: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28,377.09c134.5,0,243.55-41.17,243.55-92.08s-109.05-92.24-243.55-92.24c-134.66,0-243.7,41.33-243.7,92.24s109,92.08,243.7,92.08Z",
    style: {
      fill: "#2f5e9c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28,367.66c-129.16,0-234.12-36.77-234.12-82.65,0-45.73,105-83,234.12-83,129.48,0,234.28,37.24,234.28,83s-104.8,82.65-234.28,82.65Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28,361.22c125.23,0,226.9-34.1,226.9-76.21,0-42-101.67-76-226.9-76S46.55,243.05,46.55,285c0,42.11,101.35,76.21,226.73,76.21Z",
    style: {
      fill: "#2f5e9c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.13,305c-.63,0-1.73,1.41-2.36,2.2-3,3.15-15.39,16-22.15,16.35,1.41,0-2.36.77-2.67-2.21a2.35,2.35,0,0,1,0-.27c0-1.83,1.45-4,2.05-5.23l33.63-59.55H398.2l-20.27,34.26c-1.57-3.15-3.92-10.53-13.2-10.69-15.4-.16-21.37,10.37-32.05,20.43-3.14,2.83-6.92,6.6-15.56,6.6-5,0-8.95-4.08-8-9.27.63-4.08,2-6.13,5-7.23,1.42,4.09,4.08,6.28,8.64,6.28,5.19-.15,8.17-4.87,8.33-8.95,0-3.46-2.2-7.86-8.49-8.17-5.81-.32-10.21,2.35-16.49,9.58,0,0,1.56-10.68-10.22-10.37a8,8,0,0,0-3.77.63c-6.44,2-14.77,12.41-21.37,20.42a24,24,0,0,0,.31-4.71c0-4.55-1.72-10.53-4.87-13.67a2.28,2.28,0,0,0-1.88-.63c-2.05,0-3.78,1.73-3.78,4.41a14.76,14.76,0,0,1,3.62,9.27c0,3.77-1.1,10.68-2.67,13.35-6,10.22-13.51,16.82-22.63,15.4-4.87-1.1-8.17-5.82-7.23-12.88.48-4.09,3-9.75,5.35-13.2a29.93,29.93,0,0,1,19.79-12.26s.48-1.88-.78-2.83c-.47-.78-1.1-1.72-3.3-1.72-13.35.46-21.53,10.05-26.24,19.47-1.73,3.31-4.25,8-5.66,11,0,0-1.25,3.46-7.07,7.85-3,2.36-3.93,3.15-4.4,3a7.19,7.19,0,0,0,2.36,3.93c.47.31,2-.63,2.67-.94,7.39-4.25,8.17-6.29,8.17-6.29,1.57,8.79,9.11,13.35,17.44,13.35,11.48,0,22-10.37,28.13-19.48a178.59,178.59,0,0,1,15.24-19c3.46-3.29,7.07-5.49,9.27-5.49a3.1,3.1,0,0,1,3,3.77,36.24,36.24,0,0,1-1.51,4.95,40.49,40.49,0,0,1-2.57,5.42l-17.13,29.06h13.36c7.7-14.45,8-14.91,15.56-28.74,2,7.69,6.12,10.68,12.72,10.83,5.66.17,9.58-.15,13.83-2.35a18.19,18.19,0,0,0,.94,11.78c1.57,3.61,4.72,8.17,12.42,8.33,9.27,0,18.37-4.08,21.05-6.45.78,4.56,3,6.93,8.8,6.93,11.78-.33,22.15-12.42,28.44-20.28,1.1-1.41,2.52-3.77,2.52-4.39C404,305.6,402.75,305,402.13,305Zm-30.95-3.77s-5.35,8.95-10.85,14.45c-9.74,9.91-16,6.6-17.43,5.51s-2.52-5-1.89-9c.47-3.93,3.45-10.53,6.28-14,5.65-6.92,12.57-11.64,18.08-11,4.18.48,6,3.21,6,6.67a14.86,14.86,0,0,1-1.93,6.84Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,232.53c0,5-17.6,14.61-32.53,14.61-23.25,0-47.45-11.16-58.61-13.67-12.1-2.83-23.09-5.19-31.74-5.19-30.32,0-43.84,13-43.21,25,.32,4.87,4.24,8,10.06,6.91,6.28-1.1,15.08-7.07,17.28-12.26a1.68,1.68,0,0,1,2.2-.94,1.9,1.9,0,0,1,.63,1.89C205.4,255,196,272,179.64,272c-9.12,0-15.25-8.49-15.09-16.82.16-15.55,16-31.27,55.15-31.27a146.49,146.49,0,0,1,24.83,2.2c10.53,1.89,36.77,6.29,58.14,6.6,7.85,0,17.91.32,26.08-.94,8.64-1.42,6.76-1.73,10.21-1.73,3.15,0,3.15,1.26,3.15,2.52Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.46,257a5.52,5.52,0,0,0-4.72-5.34c-5-.79-9,3.29-9.42,10.05a15.45,15.45,0,0,0,.62,3.77,202.29,202.29,0,0,1-20.42,2.36c11.62-19.64,22.31-26.56,25.45-29.38a16.42,16.42,0,0,0,2.36-2.52,1.75,1.75,0,0,0-.4-2,1.65,1.65,0,0,0-1-.49,2.52,2.52,0,0,0-.63.07c-4.84,1.06-22,14.3-35.5,35-3.62.47-18.7,1.73-23.73,7.38a5.6,5.6,0,0,0-.94,2.05c.31,1.25,1.25,1.88,2.67.78,3.14-3.61,15.87-5,18.85-5.18-18.54,26.08-35.67,43.21-50.91,43.21a17.39,17.39,0,0,1-4.87-.32c-6.13-1.41-9.74-7.85-9.74-13.67,0-7.7,7.38-16,11.63-17.6,1.41-.62,2-1.41,2-2,0-.94-.63-1.57-2.36-1.57-14.61,3.61-22.47,15.56-22.31,25.3.32,16,12.41,25,26.08,25,19.17,0,28.92-8.33,60.18-58.92,12.42-1.26,18.55-2,24.83-3.14,0,0,1.89,4.55,6.6,4.55.79.16.63-.63,1.1-2.35-2-.16-4.4-1.58-4.4-3.3a29,29,0,0,0,4.87-3.15C257.42,263.64,259.46,259.71,259.46,257Zm-9.75,8.17a10.2,10.2,0,0,1,0-6.13,5,5,0,0,1,4.41-3.93c1.09-.16,1.57.94,1.72,1.89.32,1.88-1.25,4.71-2.2,5.65C251.29,265.37,249.71,265.21,249.71,265.21Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFordLogo);
export default __webpack_public_path__ + "static/media/ford_logo.172039e412e6d0bebcccb743f77c1594.svg";
export { ForwardRef as ReactComponent };